<script setup lang="ts">
  import { FormInput, SearchCombobox } from '@/shared/ui';
  import { MAX_POSITION_LENGTH } from '@/entities/Position';

  interface Props {
    position: string;
    departmentId: string;
    departmentOptions: Array<{ value: string; label: string }>;
    departmentLoading?: boolean;
    initialDepartmentLabel?: string;
    maxLengthLabel?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    departmentLoading: false,
    initialDepartmentLabel: undefined,
    maxLengthLabel: true,
  });

  const emit = defineEmits<{
    (e: 'update:position', value: string): void;
    (e: 'update:departmentId', value: string): void;
    (e: 'department-search', value: string): void;
  }>();

  const handlePositionChange = (value: string) => {
    emit('update:position', value);
  };

  const handleDepartmentChange = (value: string) => {
    emit('update:departmentId', value);
  };
</script>

<template>
  <div class="px-6 py-6 space-y-6">
    <div class="flex flex-col gap-2">
      <FormInput
        id="position"
        :model-value="position"
        label="Cargo:"
        type="text"
        placeholder="Escreva o título do Cargo"
        label-class="text-sm text-gray-07 font-semibold"
        :max-length="MAX_POSITION_LENGTH"
        @update:model-value="handlePositionChange"
      />
      <div
        v-if="maxLengthLabel"
        class="flex justify-between items-center"
      >
        <span class="text-xs text-gray-05">
          Número máximo de caracteres: {{ position.length }}/{{ MAX_POSITION_LENGTH }}
        </span>
      </div>
    </div>

    <hr class="border-t border-gray-02 -mx-6">

    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-07 font-semibold">Departamento:</label>
      <SearchCombobox
        :model-value="departmentId"
        :options="departmentOptions"
        :disabled="departmentLoading"
        :loading="departmentLoading"
        :initial-label="initialDepartmentLabel"
        placeholder="Selecione um Departamento"
        search-placeholder="Buscar departamento..."
        class="w-auto max-w-xs"
        @update:model-value="handleDepartmentChange"
        @search="emit('department-search', $event)"
      />
    </div>
  </div>
</template>
